import type { Editor as EditorArg } from "tinymce";

export function onEditorEnter(event: KeyboardEvent, editor: EditorArg) {
  if (event.key !== "Enter") return;

  const selection = editor.selection;
  const node = selection.getNode();
  const ssmlElement = node.closest("[data-ssml]");

  if (!ssmlElement) return;

  const ssmlValue = ssmlElement.getAttribute("data-ssml") || "";
  if (!ssmlValue.includes("-")) return;

  event.preventDefault();

  const p = editor.dom.create("p");
  const br = editor.dom.create("br");
  p.appendChild(br);

  const currentP = node.closest("p");
  if (currentP && currentP.parentNode) {
    currentP.parentNode.insertBefore(p, currentP.nextSibling);

    const newRange = editor.dom.createRng();
    newRange.setStart(p, 0);
    newRange.setEnd(p, 0);
    selection.setRng(newRange);

    editor.fire("change");
  }
}
